let currentAppConfig = {};

export const initConfig = appConfigKey => {
  currentAppConfig = appConfig[appConfigKey] || appConfig.default;

  return currentAppConfig;
};

export const getAppConfig = () => currentAppConfig;

const appConfig = {
  default: {
    subscriptionPage: 'https://app.spectrebowling.com/registration',
    apiServer: 'https://app.spectrebowling.com/api/',
    importServer: 'https://app.spectrebowling.com/api/',
    fileServer: 'https://app.spectrebowling.com/files/',
    appUrl: 'https://app.spectrebowling.com/',
    resettingPage: 'https://app.spectrebowling.com/resetting/request',
    commSocket: 'wss://app.spectrebowling.com/comm',
  },
  'app.spectrebowling.com': {
    subscriptionPage: 'https://app.spectrebowling.com/registration',
    apiServer: 'https://app.spectrebowling.com/api/',
    importServer: 'https://app.spectrebowling.com/api/',
    fileServer: 'https://app.spectrebowling.com/files/',
    appUrl: 'https://app.spectrebowling.com/',
    resettingPage: 'https://app.spectrebowling.com/resetting/request',
    commSocket: 'wss://app.spectrebowling.com/comm',
  },
  'local.spectrebowling.com': {
    subscriptionPage: 'http://local.spectrebowling.com/registration',
    apiServer: 'http://local.spectrebowling.com/api/',
    importServer: 'http://local.spectrebowling.com/api/',
    fileServer: 'http://local.spectrebowling.com/files/',
    appUrl: 'http://local.spectrebowling.com/',
    resettingPage: 'http://local.spectrebowling.com/resetting/request',
    commSocket: 'wss://local.spectrebowling.com/comm',
  },
};
